import { Suspense } from "react";
import { Outlet } from "react-router";
import MenuNavContainer from "../MenuNavContainer/MenuNavContainer";
import CustomLoader from "../shared/Loader/Loader";

const AppLayout = ({ userName }: { userName: string }) => {
  return (
    <>
      <MenuNavContainer userName={userName} />
      {/* Lazy route chunks suspend while their JS downloads. This boundary keeps
          the nav shell mounted and shows a loader only in the page area. */}
      <Suspense fallback={<CustomLoader />}>
        <Outlet />
      </Suspense>
    </>
  );
};

export default AppLayout;
